import { config } from "@/utils/config";

export function useCurrentSite()
{
    return {
        isAS: () => config('ek.site_id') === 'AS',
        isCU: () => config('ek.site_id') === 'CU',
    };
}
